import { Component } from '@angular/core';
import { ProcessPaymentComponent } from "./components/process-payment/process-payment.component";

@Component({
  selector: 'shared-mercado-pago',
  imports: [ProcessPaymentComponent],
  templateUrl: './mercado-pago.component.html',
  styleUrl: './mercado-pago.component.css'
})
export class MercadoPagoComponent {

}
